var module = angular.module('octopusApp.shared');

module.controller('TemplateParameterEditController', function ($scope, busy, $uibModalInstance, title, parameter, invalidStepTypes, names, requiredPermission, projectId) {
    var isSaving = $scope.isSaving = busy.create();
    $scope.title = title;
    $scope.parameter = parameter;
    $scope.invalidStepTypes = invalidStepTypes;
    $scope.requiredPermission = requiredPermission;
    $scope.projectId = projectId;
    $scope.originalName = parameter.Name;

    $scope.controlTypes = {
        "SingleLineText": "Single-line text box",
        "MultiLineText": "Multi-line text box",
        "Select": "Drop down",
        "Checkbox": "Checkbox",
        "Sensitive": "Sensitive/password box",
        "StepName": "A previous deployment step name",
        "AzureAccount": "Azure Account",
        "Certificate": "Certificate"
    };

    if (!$scope.parameter.DisplaySettings) {
        $scope.parameter.DisplaySettings = {};
        $scope.parameter.DisplaySettings['Octopus.ControlType'] = 'SingleLineText';
    }
    $scope.controlType = parameter.DisplaySettings['Octopus.ControlType'];

    $scope.sensitivity =  {
        value: null
    };

    // If no default or its an empty string, then set default to null to force correct form element to show
    if (!parameter.DefaultValue || parameter.DefaultValue === "") {
        $scope.sensitivity.value = null;
    } if (typeof parameter.DefaultValue === "string") {
        $scope.sensitivity.value = null;
    } else {
        $scope.sensitivity.value = parameter.DefaultValue;
    }

    if ($scope.controlType === 'Sensitive') {
        if (typeof parameter.DefaultValue !== 'object' && parameter.DefaultValue !== "") {
            $scope.sensitivity.isBound = true;
        } else {
            parameter.DefaultValue = null;
        }
    }

    $scope.$watch(function(){
       return parameter.Name;
    }, function(newValue, oldValue){
        $scope.showRenameWarning = $scope.originalName && newValue !== $scope.originalName;
    });

    $scope.$watch(function(){
        return parameter.DisplaySettings['Octopus.ControlType'];
    }, function(toValue, fromValue) {
        $scope.controlType = toValue;
    });


    $scope.apply = function () {
        if (!parameter.Name || parameter.Name === '') {
            isSaving.showError('Please provide a variable name for the parameter.');
            return;
        }
        if (_.contains(names, parameter.Name)) {
            isSaving.showError('This parameter variable name is already in use. Please provide a unique name.');
            return;
        }

        // Select options makes sense only for Select control type.
        if ($scope.controlType !== "Select" && parameter.DisplaySettings && parameter.DisplaySettings["Octopus.SelectOptions"])
        {
            delete parameter.DisplaySettings["Octopus.SelectOptions"];
        }

        if ($scope.controlType === 'Sensitive') {
            if (!$scope.sensitivity.isBound) {
                if ($scope.sensitivity.value == null || (!$scope.sensitivity.value.HasValue && ($scope.sensitivity.value.NewValue === null || $scope.sensitivity.value.NewValue === ""))) {
                    parameter.DefaultValue = null;
                } else {
                    if ($scope.sensitivity.value.HasValue === undefined) {
                        $scope.sensitivity.value.HasValue = true;
                    }
                    parameter.DefaultValue = $scope.sensitivity.value;
                }
            }
        }

        $uibModalInstance.close(parameter);
    };

    $scope.cancel = function () {
        $uibModalInstance.close();
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/controllers/template_edit_parameter_controller.js
// module id = 1403060681040800
// module chunks = 1